import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import {
  Box,
  Button,
  MenuItem,
  TextField,
  Typography,
  Snackbar,
} from "@material-ui/core";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import { Paper } from "@mui/material";
import axiosInstance from "../../api";
import {
  PlayCircle,
  PauseCircle,
  DisabledByDefault,
} from "@mui/icons-material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { MUIInput, MUISelect } from "../../utils/formUtils";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import addressData from "../../data/addressData.json";
import { Alert } from "@material-ui/lab";
import PageviewIcon from "@mui/icons-material/Pageview";
import { useUserContext } from "../../context/UserContext";
import InsertCommentOutlinedIcon from "@mui/icons-material/InsertCommentOutlined";
import AdminAgentDashboard from "../agents/AdminAgentDashboard";
import CommentsListViewTile from "../agents/CommentsListViewTile";
import * as ReactGA from "react-ga";

const validationSchema = yup.object().shape({
  email: yup.string().email("Email should be in valid format").nullable(),
  firstName: yup.string().nullable(),
  lastName: yup.string().nullable(),
  cagLoginName: yup.string().nullable(),
  dfsLicense: yup.string().nullable(),
  phoneNumber: yup
    .string()
    .phone("US", false, "Phone must be a valid US phone number")
    .nullable(),
  agencyName: yup.string().nullable(),
  userRole: yup.string().nullable(),
});

export default function ListUsers() {
  const [usersListdata, setUsersListData] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [pageToShow, setPageToShow] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [numberOfRecordsPerPage, setNumberOfRecordsPerPage] = useState(60);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(validationSchema) });
  const [userRoleList, setUserRoleList] = useState([]);
  const [openSnackBarError, setOpenSnackBarError] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState(null);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const { user, dispatch } = useUserContext();
  const [agentId, setAgentId] = useState();
  const [isAgentClicked, setIsAgentClicked] = useState(false);
  const [isCommentListViewClicked, setIsCommentListViewClicked] =
    useState(false);

  const [state, setState] = useState({
    firstName: "",
    lastName: "",
    cagLoginName: "",
    dfsLicense: "",
    phoneNumber: "",
    agencyName: "",
    email: "",
    userRole: 0,
    userRoleDescription: "",
  });

  useEffect(() => {
    setShowSpinner(true);
    setUserRoleList(addressData.fmapROle);
  });

  const getUsersList = (searchCiteria, searchClicked) => {
    axiosInstance
      .post(`admin/get-users`, searchCiteria)
      .then((data) => {
        let previousArray = [];
        if (!searchClicked) {
          previousArray = [...usersListdata];
        }
        let usersData = [];
        usersData = previousArray.concat(data.resultList);
        // console.log('userdata',usersData)
        setUsersListData(
          usersData.map((i) => ({
            ...i,
            status:
              i.active === "Y" && i.locked === "N"
                ? "Active"
                : i.active === "Y" && i.locked === "Y"
                ? "Suspended"
                : i.active==='N' && i.locked==='Y' && i.lockedReason==='Admin Withdrawn'
                ? "Admin Withdrawn"
                : i.active==='N' && i.locked==='Y' && i.lockedReason==='Agent Withdrawn'
                ? "Agent Withdrawn"
                : "Terminated",
          }))
        );
        //console.log("userdata", usersListdata);
        //setUsersListData(usersData);
        setShowTable(true);
        setShowSpinner(false);
      })
      .catch((err) => {});
  };

  const handleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const handleSearch = () => {
    ReactGA.event({
      category: "Search",
      action: "Click the search button from ListUsers Page",
    });
    if (
      state.firstName !== "" ||
      state.lastName !== "" ||
      state.cagLoginName !== "" ||
      state.dfsLicense !== "" ||
      state.phoneNumber !== "" ||
      state.agencyName !== "" ||
      state.email !== "" ||
      state.userRole !== 0
      //Number(state.userRole) !== 0
    ) {
      setShowSpinner(true);
      setShowTable(false);
      setUsersListData([]);
      setCurrentPage(1);
      setPageToShow(0);
      const userRoleToUse = userRoleList.filter(
        (role) => role.key === state.userRole
      );
      const searchCiteria = {
        firstName: state.firstName,
        lastName: state.lastName,
        cagLoginName: state.cagLoginName,
        dfsLicense: state.dfsLicense,
        phoneNumber: state.phoneNumber,
        agencyName: state.agencyName,
        email: state.email,
        userRole:
          state.userRole === 0
            ? ""
            : userRoleToUse[0].value !== "None"
            ? userRoleToUse[0].value
            : "",
        numberOfRecordsPerPage: numberOfRecordsPerPage,
        pageToShow: currentPage,
        includeSortBy: true,
        sortBy: "firstName",
      };
      getUsersList(searchCiteria, true);
    } else {
      setSnackBarMessage("Enter at least one search criteria to proceed.");
      setOpenSnackBarError(true);
    }
  };

  const handleClear = () => {
    setState({
      firstName: "",
      lastName: "",
      cagLoginName: "",
      dfsLicense: "",
      phoneNumber: "",
      agencyName: "",
      email: "",
      userRole: 0,
    });
  };

  const handleChangePage = (event, newPage) => {
    const currentPageNumber = usersListdata.length / rowsPerPage - 1;
    if (currentPageNumber === newPage) {
      const newPageNumber = currentPage + 1;
      setShowTable(false);
      setShowSpinner(true);
      setCurrentPage(newPageNumber);
      const userRoleToUse = userRoleList.filter(
        (role) => role.key === state.userRole
      );
      const searchCiteria = {
        firstName: state.firstName,
        lastName: state.lastName,
        cagLoginName: state.cagLoginName,
        dfsLicense: state.dfsLicense,
        phoneNumber: state.phoneNumber,
        agencyName: state.agencyName,
        email: state.email,
        userRole:
          state.userRole === 0
            ? ""
            : userRoleToUse[0].value !== "None"
            ? userRoleToUse[0].value
            : "",
        numberOfRecordsPerPage: numberOfRecordsPerPage,
        pageToShow: newPageNumber,
        includeSortBy: true,
        sortBy: "firstName",
      };
      getUsersList(searchCiteria, false);
    }
    setPageToShow(newPage);
  };

  const updateUsers = (type, row) => (e) => {
    axiosInstance
      .post(`admin/update-user/${type}/${type}`, row)
      .then((data) => {
        const userRoleToUse = userRoleList.filter(
          (role) => role.key === state.userRole
        );
        const searchCiteria = {
          firstName: state.firstName,
          lastName: state.lastName,
          cagLoginName: state.cagLoginName,
          dfsLicense: state.dfsLicense,
          phoneNumber: state.phoneNumber,
          agencyName: state.agencyName,
          email: state.email,
          userRole:
            state.userRole === 0
              ? ""
              : userRoleToUse[0].value !== "None"
              ? userRoleToUse[0].value
              : "",
          numberOfRecordsPerPage: numberOfRecordsPerPage,
          pageToShow: 1,
          includeSortBy: true,
          sortBy: "firstName",
        };
        setSnackBarMessage("User status updated successfully!");
        setOpenSnackBar(true);
        setUsersListData([]);
        setCurrentPage(1);
        setPageToShow(0);
        setShowTable(false);
        setShowSpinner(true);
        getUsersList(searchCiteria, true);
      })
      .catch((err) => {
        setSnackBarMessage("Failed to update User status");
        setOpenSnackBarError(true);
      });
  };

  const agentInformation = (row) => (e) => {
    setAgentId(row.agentId);
    setIsAgentClicked(true);
    setIsCommentListViewClicked(false);
  };

  const commentListView = (row) => (e) => {
    setAgentId(row.agentId);
    setIsCommentListViewClicked(true);
    setIsAgentClicked(false);
  };

  const onReturnBack = () => {
    setIsAgentClicked(false);
    setIsCommentListViewClicked(false);
  };

  const handleSnackBarClose = (event, reason) => {
    setOpenSnackBar(false);
    setOpenSnackBarError(false);
  };

  return (
    <React.Fragment>
      {!isAgentClicked && !isCommentListViewClicked && (
        <Box m={3}>
          <Snackbar
            open={openSnackBar}
            autoHideDuration={6000}
            onClose={handleSnackBarClose}
          >
            <Alert
              variant="filled"
              onClose={handleSnackBarClose}
              severity="success"
            >
              {snackBarMessage}
            </Alert>
          </Snackbar>

          <Snackbar
            open={openSnackBarError}
            autoHideDuration={6000}
            onClose={handleSnackBarClose}
          >
            <Alert
              variant="filled"
              onClose={handleSnackBarClose}
              severity="error"
            >
              {snackBarMessage}
            </Alert>
          </Snackbar>

          <Typography
            variant="h4"
            align="left"
            component="h4"
            gutterBottom
            style={{ paddingLeft: 24, fontWeight: 600 }}
          >
            User Search <PersonSearchIcon />
          </Typography>

          <Typography
            variant="h6"
            align="left"
            component="h6"
            gutterBottom
            style={{ paddingLeft: 24, marginBottom: 16 }}
          >
            Enter at-least a search criteria to proceed.
          </Typography>

          <Paper style={{ padding: 24 }}>
            <Grid
              container
              alignItems="flex-start"
              spacing={3}
              style={{ marginBottom: 3 }}
            >
              <Grid item xs={12} sm={6} md={4}>
                <MUIInput
                  control={control}
                  name="firstName"
                  defaultValue={state?.firstName}
                  inputPrp={{ maxLength: 40 }}
                  value={state?.firstName}
                  label="First Name"
                  onInputChange={handleChange}
                  errors={errors}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <MUIInput
                  control={control}
                  name="lastName"
                  defaultValue={state?.lastName}
                  inputPrp={{ maxLength: 40 }}
                  value={state?.lastName}
                  label="Last Name"
                  onInputChange={handleChange}
                  errors={errors}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <MUIInput
                  control={control}
                  name="cagLoginName"
                  defaultValue={state?.cagLoginName}
                  inputPrp={{ maxLength: 40 }}
                  value={state?.cagLoginName}
                  label="CAG Login Name"
                  onInputChange={handleChange}
                  errors={errors}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <MUIInput
                  control={control}
                  name="dfsLicense"
                  defaultValue={state?.dfsLicense}
                  inputPrp={{ maxLength: 40 }}
                  value={state?.dfsLicense}
                  label="DFS License"
                  onInputChange={handleChange}
                  errors={errors}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <MUIInput
                  control={control}
                  name="agencyName"
                  defaultValue={state?.agencyName}
                  inputPrp={{ maxLength: 40 }}
                  value={state?.agencyName}
                  label="Agency Name"
                  onInputChange={handleChange}
                  errors={errors}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <MUIInput
                  control={control}
                  name="phoneNumber"
                  defaultValue={state?.phoneNumber}
                  inputPrp={{ maxLength: 40 }}
                  value={state?.phoneNumber}
                  label="Phone Number"
                  onInputChange={handleChange}
                  errors={errors}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <MUIInput
                  control={control}
                  name="email"
                  defaultValue={state?.email}
                  inputPrp={{ maxLength: 40 }}
                  value={state?.email}
                  label="Email"
                  onInputChange={handleChange}
                  errors={errors}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <MUISelect
                  id="userRole"
                  control={control}
                  name="userRole"
                  label="App Role"
                  errors={errors}
                  value={state?.userRole}
                  required="true"
                  defaultValue={state?.userRole}
                  //onChange={handleChange}
                  onFormChange={handleChange}
                >
                  {userRoleList.map((r) => {
                    return (
                      <MenuItem key={r.key} value={r.key}>
                        {r.value}
                      </MenuItem>
                    );
                  })}
                </MUISelect>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Button
                  type="search"
                  variant="contained"
                  color="primary"
                  name="btnSearch"
                  onClick={handleSearch}
                >
                  Search
                </Button>
                &nbsp;&nbsp;
                <Button
                  type="search"
                  variant="contained"
                  color="primary"
                  name="clrSearch"
                  onClick={handleClear}
                >
                  Clear
                </Button>
              </Grid>
            </Grid>
          </Paper>

          {showTable && usersListdata.length === 0 && (
            <>
              <br />
              <Box
                component="span"
                display="flex"
                style={{ backgroundColor: "lightblue", marginBottom: 5 }}
                p={2}
              >
                No users match for your search criteria.
              </Box>
              <br />
              <br />
            </>
          )}
          {showTable && usersListdata.length > 0 && (
            <Grid container style={{ marginTop: "1rem" }}>
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableHead style={{ backgroundColor: "#1c2438" }}>
                    <TableRow>
                      {/* <TableCell>S.NO</TableCell> */}
                      <TableCell style={{ color: "#ffffff" }}>Name</TableCell>
                      <TableCell style={{ color: "#ffffff" }}>
                        CAG Login
                      </TableCell>
                      <TableCell style={{ color: "#ffffff" }}>Phone</TableCell>
                      <TableCell style={{ color: "#ffffff" }}>Email</TableCell>
                      <TableCell style={{ color: "#ffffff" }}>
                        DFS License Number
                      </TableCell>
                      <TableCell style={{ color: "#ffffff" }}>Role</TableCell>
                      <TableCell style={{ color: "#ffffff" }}>Status</TableCell>
                      <TableCell style={{ color: "#ffffff" }}>
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {usersListdata
                      .slice(
                        pageToShow * rowsPerPage,
                        pageToShow * rowsPerPage + rowsPerPage
                      )
                      .map((row, i) => (
                        <TableRow key={i}>
                          <TableCell>
                            {`${row.firstName} ${row.lastName}`}
                          </TableCell>
                          <TableCell>{row.cagLogin}</TableCell>
                          <TableCell>{row.phoneNumber}</TableCell>
                          <TableCell>{row.email}</TableCell>
                          <TableCell>
                            {row.userRoleCode === "FMAP_AGENT"
                              ? row.dfsLicense
                              : "N/A"}
                          </TableCell>
                          <TableCell>{row.userRoleDescription}</TableCell>
                          <TableCell>{row.status}</TableCell>
                          <TableCell>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                              }}
                            >
                              {row.active === "Y" &&
                                row.userRoleCode === "FMAP_AGENT" &&
                                user.fmapRole === "FMAP_ADMIN" && (
                                  <DisabledByDefault
                                    titleAccess={"Terminate"}
                                    onClick={updateUsers("terminate", row)}
                                    style={{
                                      marginRight: "0.75rem",
                                      cursor: "pointer",
                                    }}
                                  />
                                )}
                              {row.active === "N" &&
                                row.userRoleCode === "FMAP_AGENT" &&
                                user.fmapRole === "FMAP_ADMIN" && (
                                  <CheckBoxIcon
                                    titleAccess={"Activate"}
                                    onClick={updateUsers("activate", row)}
                                    style={{
                                      marginRight: "0.75rem",
                                      cursor: "pointer",
                                    }}
                                  />
                                )}
                              {row.active === "Y" &&
                                row.locked === "N" &&
                                row.userRoleCode === "FMAP_AGENT" &&
                                user.fmapRole === "FMAP_ADMIN" && (
                                  <PauseCircle
                                    titleAccess={"suspend"}
                                    onClick={updateUsers("suspend", row)}
                                    style={{
                                      marginRight: "0.75rem",
                                      cursor: "pointer",
                                    }}
                                  />
                                )}
                              {row.active === "Y" &&
                                row.locked === "Y" &&
                                row.userRoleCode === "FMAP_AGENT" &&
                                user.fmapRole === "FMAP_ADMIN" && (
                                  <PlayCircle
                                    titleAccess={"unsuspend"}
                                    onClick={updateUsers("unsuspend", row)}
                                    style={{ cursor: "pointer" }}
                                  />
                                )}
                              {row.userRoleCode === "FMAP_AGENT" &&
                                user.fmapRole === "FMAP_ADMIN" && (
                                  <PageviewIcon
                                    titleAccess={"Agent Dashboard Information"}
                                    onClick={agentInformation(row)}
                                    style={{ cursor: "pointer" }}
                                  />
                                )}
                              {row.userRoleCode === "FMAP_AGENT" &&
                                (user.fmapRole === "FMAP_ADMIN" ||
                                  user.fmapRole === "FMAP_CC_USER") && (
                                  <InsertCommentOutlinedIcon
                                    titleAccess={"Update Agent Comments"}
                                    onClick={commentListView(row)}
                                    style={{ cursor: "pointer" }}
                                  />
                                )}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Grid
                container
                alignItems="center"
                justifyContent="flex-end"
                columns={20}
                m={0}
                style={{ background: "#fff" }}
              >
                <TablePagination
                  rowsPerPageOptions={[10]}
                  component="div"
                  count={usersListdata.length}
                  rowsPerPage={rowsPerPage}
                  page={pageToShow}
                  onPageChange={handleChangePage}
                  //onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Grid>
            </Grid>
          )}
        </Box>
      )}
      {isAgentClicked && (
        <Box m={2}>
          <AdminAgentDashboard agentId={agentId} onReturnBack={onReturnBack} />
        </Box>
      )}
      {isCommentListViewClicked && (
        <Box m={2}>
          <CommentsListViewTile agentId={agentId} onReturnBack={onReturnBack} />
        </Box>
      )}
    </React.Fragment>
  );
}
